import { split } from 'lodash-es';

import { CIError } from 'common/error/error_util';
import gqlClient from 'common/graphql/client';
import { CILogger } from 'common/log/log.provider';

import { GetStudyPendoMetadataQuery } from './queries';

export interface StudyPendoMetadata {
    customerId?: string;
    customerName?: string;
    sponsorId?: string;
    sponsorName?: string;
}

/** Customer and sponsor share one source and one resolution point — the study being reported. */
export async function fetchStudyPendoMetadata(studyId?: string): Promise<StudyPendoMetadata> {
    if (!studyId) {
        return {};
    }

    try {
        const { data } = await gqlClient.query({
            query: GetStudyPendoMetadataQuery,
            // The study id can carry a version suffix (e.g. "study.x#3"); getStudy expects the base pk.
            variables: { pk: split(studyId, '#')?.[0] },
            // Always resolve from the backend — a cache-first hit could report blank fields.
            fetchPolicy: 'network-only',
        });

        // undefined, never '' — a study legitimately has no sponsor and Pendo needs an absent field.
        return {
            customerId: data.getStudy?.customerId ?? undefined,
            customerName: data.getStudy?.customerName ?? undefined,
            sponsorId: data.getStudy?.sponsorId ?? undefined,
            sponsorName: data.getStudy?.sponsorName ?? undefined,
        };
    } catch (err) {
        CILogger.getInstance().error(
            'Failed to fetch study customer/sponsor for Pendo identify',
            CIError.fromGraphQLError(err)
        );

        return {};
    }
}
